import React, { useContext } from 'react'
import DashboardCard from '../DashnoardComponents/DashboardCard/DashboardCard'
import task_overview from '../../../Assets/DashboardImages/task_overview.png';
import total_engineers from '../../../Assets/DashboardImages/total_engineers.png';
import total_sites from '../../../Assets/DashboardImages/total_sites.png';
import { FaBuilding, FaUsers } from 'react-icons/fa';
import { BsGraphUpArrow } from 'react-icons/bs';
import { Box } from '@mui/material';
import { Grid } from '@mui/joy';
import { Card } from 'react-bootstrap';
import EmployeesAvailabilityCard from './SupervisorDashboardComponents/EmployeesAvailabilityCard/EmployeesAvailabilityCard';
import EquipmentStatusCard from './SupervisorDashboardComponents/EquipmentStatusCard/EquipmentStatusCard';
import WorkUtilization from './SupervisorDashboardComponents/WorkUtilization/WorkUtilization';
import ScheduleOverview from './SupervisorDashboardComponents/ScheduleOverview/ScheduleOverview';
import WorkSitesOverview from './SupervisorDashboardComponents/WorkSitesOverview/WorkSitesOverview';
import { dashboardContext } from '../Dashboard';
import CustomSkelton from '../../../Components/Skeletons/CustomSkelton';
import useScreenSize from '../../../utils/useScreenSize';
import TextSkeleton from '../../../Components/Skeletons/TextSkeleton';

function SupervisorDashboard() {
    const { data, isLoading } = useContext(dashboardContext);
    const { width } = useScreenSize();

    const columnStyle = { display: 'flex', gap: '20px', marginBottom: '20px', padding: '10px', width: '100%' };
    const renderSkeletonCard = () => (
        <div style={columnStyle}>
            <CustomSkelton
                variant="rounded"
                height={140}
                width={`100%`}
                animation="wave"
                style={{ borderRadius: '12px', marginRight: '20px' }}
            />
        </div>
    );

    return (
        <>
            <div className="dashboard-header">{isLoading ? <TextSkeleton width='15%' fontSize='3rem' /> : `Dashboard`} </div>

            <div className="dashboard-card-main-container">
                {isLoading ? (
                    <>
                        <CustomSkelton
                            height={140}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={140}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={140}
                            width={width > 600 ? '33%' : '100%'}
                        />
                    </>
                ) : (
                    <>
                        <DashboardCard
                            color1="#9575CD"
                            color2="#A67DFF"
                            image={total_sites}
                            title="Worksites"
                            count={data?.WorksitesCount || `N/A`}
                            icon={<FaBuilding />}
                        />
                        <DashboardCard
                            color1="#1E88E5"
                            color2="#439DFE"
                            image={total_engineers}
                            title="Active Users"
                            count={data?.EmployeeCount || `N/A`}
                            icon={<FaUsers />}
                        />
                        <DashboardCard
                            color1="#FFB74D"
                            color2="#FDB73B"
                            image={task_overview}
                            title="Active Schedules"
                            count={data?.scheduleCount || `N/A`}
                            icon={<BsGraphUpArrow />}
                        />
                    </>
                )}
            </div>

            <Box sx={{ padding: 3, paddingLeft: 0, paddingRight: 0 }}>
                <Grid container spacing={3}>
                    {/* Left Section */}
                    <Grid item xs={12} md={8}>
                        <Box mb={5}>
                            <Card sx={{ padding: 2 }}>
                                {isLoading ? (
                                    <>
                                        {renderSkeletonCard()} {renderSkeletonCard()} {renderSkeletonCard()}
                                    </>
                                ) : (
                                    <ScheduleOverview data={data} />
                                )}
                            </Card>
                        </Box>

                        {/* Optional: if you include WorkSitesOverview */}
                        {/* <Card sx={{ padding: 2 }}>
              {isLoading ? (
                <CustomSkelton variant="rectangular" height={250} />
              ) : (
                <WorkSitesOverview data={data} />
              )}
            </Card> */}
                    </Grid>

                    {/* Right Section */}
                    <Grid item xs={12} md={4}>
                        <Card style={columnStyle}>
                            {isLoading ? (
                                <>
                                    <TextSkeleton />
                                    <CustomSkelton variant="rectangular" height={120} />
                                </>

                            ) : (
                                <EmployeesAvailabilityCard data={data} />
                            )}
                        </Card>

                        <Card style={columnStyle}>
                            {isLoading ? (
                                <>
                                    <TextSkeleton />
                                    <CustomSkelton variant="rectangular" height={120} />
                                </>
                            ) : (

                                <WorkUtilization data={data} />
                            )}
                        </Card>

                        <Card style={columnStyle}>
                            {isLoading ? (
                                <>
                                    <TextSkeleton />
                                    <CustomSkelton variant="rectangular" height={120} />
                                </>

                            ) : (
                                <EquipmentStatusCard data={data} />
                            )}
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default SupervisorDashboard;


// function SupervisorDashboard() {
//    const { data, isLoading } = useContext(dashboardContext);

//     return (
//         <>
//             <div className="dashboard-header">Dashboard</div>
//             <div className='dashboard-card-main-container'>
//                 <DashboardCard
//                     color1="#9575CD"
//                     color2="#A67DFF"
//                     image={total_sites}
//                     title={`Worksites`}
//                     count={data?.WorksitesCount || `N/A`}
//                     icon={<FaBuilding />}
//                 />
//                 <DashboardCard
//                     color1="#1E88E5"
//                     color2="#439DFE"
//                     image={total_engineers}
//                     title={`Active Users`}
//                     count={data?.EmployeeCount || `N/A`}
//                     icon={<FaUsers />}
//                 />
//                 <DashboardCard
//                     color1="#FFB74D"
//                     color2="#FDB73B"
//                     image={task_overview}
//                     title={`Active Schedules`}
//                     subTitle={``}
//                     count={data?.scheduleCount || `N/A`}
//                     icon={<BsGraphUpArrow />}
//                 />
//             </div>
//             <Box sx={{ padding: 3 }}>
//                 <Grid container spacing={3}>
//                     {/* Left Section */}
//                     <Grid item xs={12} md={8}>
//                         <Box mb={5}>
//                             <Card sx={{ padding: 2 }}>
//                                 <ScheduleOverview data={data} />
//                             </Card>
//                         </Box>

//                         {/* <Card sx={{ padding: 2 }}>
//                             <WorkSitesOverview />
//                         </Card> */}
//                     </Grid>
//                     {/* Right Section */}
//                     <Grid item xs={12} md={4}>
//                         <Card sx={{ padding: 2, marginBottom: 3 }}>
//                             <EmployeesAvailabilityCard data={data} />
//                         </Card>
//                         <div sx={{ padding: 2, marginBottom: 3, }}>
//                             <WorkUtilization data={data} />
//                         </div>
//                         <Card sx={{ padding: 2 }}>
//                             <EquipmentStatusCard
//                                 data={data}
//                             />
//                         </Card>
//                     </Grid>
//                 </Grid>
//             </Box>
//         </>
//     )
// }

// export default SupervisorDashboard